"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsSGPostalCode = exports.isSGPostalCode = void 0;
const IsString_1 = require("../string/IsString");
const mol_validator_utils_1 = require("../utils/mol-validator-utils");
async function isSGPostalCode(value, args, constraints) {
    const isStringResults = await (0, IsString_1.isString)(value, args, constraints);
    if (isStringResults.pass === false || isStringResults.skipped) {
        return isStringResults;
    }
    const pattern = "^\\d{6}$";
    const matches = value.match(pattern);
    if (!matches) {
        return { pass: false, message: `should be a valid Singapore postal code` };
    }
    return { pass: true };
}
exports.isSGPostalCode = isSGPostalCode;
/**
 * Validates that this property is a valid NRIC/FUN
 */
function IsSGPostalCode(constraints, options) {
    return (0, mol_validator_utils_1.registerValidatorDecorator)({
        name: "IsSGPostalCode",
        defaultMessage: `should be a valid Singapore postal code`,
        options,
        constraints,
        validateFn: isSGPostalCode,
    });
}
exports.IsSGPostalCode = IsSGPostalCode;
//# sourceMappingURL=IsSGPostalCode.js.map